import React, { useEffect, useRef, useState } from 'react';
import update from 'immutability-helper';
import { Avatar } from 'antd';
import lodash from 'lodash';
import { useLocation, useNavigate } from "react-router-dom";
import TextField from '../global/fields/TextField';
import SelectField from '../global/fields/SelectField';
import Button from '../global/Button';
import UserProfileApi from '../../api/userProfile';
import OnBoardingScreen from './OnBoardingScreen';
import ProgressBar from '../global/ProgressBar';
import userPlaceholder from '../../assets/images/user_placeholder.svg';
import { screenData, policyData } from './onboardingScreenData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckboxField from '../global/fields/Checkbox';
import ConsentsApi from '../../api/consents';
import DomPurify from 'dompurify';
import { Checkbox } from 'antd';
import { extractTags } from './userTagsUtils';
import AddIcon from '../../components/Icons/AddIcon';
import { Container } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import FeatureFlagsApi from '../../api/featureFlags';
import { CUSTOM_THEME } from '../../constants/themeConstants';
import { useSearchParams } from 'react-router-dom';
import { removePreloaderToGlobalPreloadersList } from '../../actionCreators/globalPreloaders';
import { TagApi } from '../../api';
import { getHeaders, getCookieValForKey } from '../../api/helpers';

const UserProfile = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();

  const location = useLocation()
  const history = useNavigate()
  const userProfileProps = props.props;

  const fileUpload = useRef(null);

  const currentStep = +searchParams.get('currentStep') || 1;
  const profile = searchParams.get('profile') || null;

  const [state, setState] = useState({
    form: {
      fields: {
        first_name: {
          label: 'First Name',
          value: '',
          type: 'text',
          validateRule: 'name',
        },
        last_name: {
          label: 'Last Name',
          value: '',
          type: 'text',
          validateRule: 'name',
        },
        job_title: {
          label: 'Job Title',
          value: '',
          type: 'text',
          validateRule: 'name',
        },
        phone_number: {
          label: 'Phone no. (optional)',
          value: '',
          type: 'text',
          inputType: 'number',
          validateRule: 'tel',
        },
        department_id: {
          label: 'Department',
          value: '',
          type: 'dropdown',
          validateRule: 'name',
        },
      },
      validate: false,
    },
    imageBlobUrl: '',
    imageFile: null,
    showValidateBlock: false,
    validationBlockInputs: [],
    onBoardingData: [],
    userProfileData: [],
    screenIndex: currentStep,
    imageUrl: 'LOADING',
    currentAgreementAccepted: false,
    agreementsLength: null,
    firstAgreementStepIndex: null,
  });

  const dispatchInitialActions = () => {
    userProfileProps.getDepartments();
    userProfileProps.getUserTags();
    userProfileProps.fetchFeatureFlags();
  };

  const setupUserTagFields = (userTags, fields) => {
    const userTagFields = userTags.map((tag) => {
      const id = `tag-${tag.id}`;

      if (tag.type === 1) {
        return {
          id,
          label: tag.title,
          value: '',
          type: 'dropdown',
          validateRule: 'userTags',
        };
      } else if (tag.type === 2) {
        const [checkbox] = tag.options;
        return {
          id,
          label: checkbox.label,
          type: 'checkbox',
          validateRule: 'required',
        };
      } else return {};
    });
    const userTagObject = userTagFields.reduce((acc, value) => {
      acc[value.id] = value;
      return acc;
    }, {});

    const newState = {
      ...fields,
      ...userTagObject,
    };

    return newState;
  };

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      setTimeout(dispatchInitialActions, 0);
      let onBoardingData = [...state.onBoardingData];
      const featureFlagsResp = await FeatureFlagsApi.fetchFeatureFlags();
      const featureFlags = featureFlagsResp ? featureFlagsResp.feature_flags || {} : {};
      if (featureFlags['APP_ONBOARDING']) {
        onBoardingData = [...onBoardingData, ...screenData, ...policyData];
      } else {
        onBoardingData = [...onBoardingData, ...policyData];
      }
      userProfileProps.getEmployeeOnboardingTasks();

      const onboardingResp = await UserProfileApi.fetchOnBoardingData({
        token: userProfileProps.token.key,
      });

      const newOnBoardingData = lodash.cloneDeep(onBoardingData);

      if (onboardingResp && onboardingResp.screenData && onboardingResp.screenData[0]) {
        if (onboardingResp.screenData[0].image && onboardingResp.screenData[0].image.url) {
          newOnBoardingData.forEach((data) => {
            data.image = onboardingResp.screenData[0].image;
            data.image_id = onboardingResp.screenData[0].image_id;
          });
        }
        newOnBoardingData[0] = onboardingResp.screenData[0];
        if (newOnBoardingData[0].image_id && state.imageUrl === 'LOADING') {
          // TODO - I believe some work is needed on the API to pll through the correct images - currently hardcoded below (I think this is ok as its the correct image)
          // const img = await ImageApi.getImage(newOnBoardingData[0].image.url);
          //     .then((image) => {
          //       setState({ ...state, imageUrl: image });
          //     })
          //     .catch(() => {
          //       setState({ ...state, imageUrl: CUSTOM_THEME[userProfileProps.customAppId].welcome });
          //     });
          // } else {
          setState({ ...state, imageUrl: CUSTOM_THEME[userProfileProps.customAppId].welcome });
        }
      } else newOnBoardingData.shift();

      setState({ ...state, onBoardingData: newOnBoardingData });

      // TODO - I believe this also needs an API fix - I'm not sure what Image is supposed to be handled here?
      // if (onBoardingData[0].image_id && state.imageUrl === 'LOADING') {
      //   ImageApi.getImage(onBoardingData[0].image.url)
      //     .then((image) => {
      //       setState({ ...state, imageUrl: image });
      //     })
      //     .catch(() => {
      //       setState({ ...state, imageUrl: CUSTOM_THEME[userProfileProps.customAppId].welcome });
      //     });
      // } else {
      //   setState({ ...state, imageUrl: CUSTOM_THEME[userProfileProps.customAppId].welcome });
      // }

      if (
        userProfileProps.userData &&
        userProfileProps.userData.user &&
        userProfileProps.userData.user.first_name &&
        userProfileProps.userData.user.last_name &&
        userProfileProps.userData.user.job_title
      ) {
        if (userProfileProps.showEmployeeOnboard)
          userProfileProps.history('/employee_onboarding?firstTimeLogin=true');
        else userProfileProps.history('/');
      }

      const formFields = Object.assign({}, state.form.fields);
      const newFormFields = { ...formFields };

      const { tags } = await TagApi.getUserTags();

      const finalFields = setupUserTagFields(tags, newFormFields);

      // FIXME - do we still need this ?
      // setState((state) =>
      //   update(state, {
      //     form: {
      //       fields: { $set: newFormFields },
      //     },
      //     imageBlobUrl: { $set: state.imageBlobUrl },
      //   }),
      // );

      ConsentsApi.getConsents().then((resp) => {
        const agreements = [];

        if (resp.data.engage4.text) {
          agreements.push({
            header: 'Privacy Policy',
            body: DomPurify.sanitize(resp.data.engage4.text),
            ctaButtonTitle: 'CONTINUE',
          });
        }

        if (resp.data.organisation && resp.data.organisation.text) {
          agreements.push({
            header: 'Organisation Terms',
            body: DomPurify.sanitize(resp.data.organisation.text),
          });
        }

        const beforeAgreements = onBoardingData.slice(0, -1);
        const afterAgreements = onBoardingData.slice(-1);

        setState({
          ...state,
          onBoardingData: [
            onboardingResp.screenData[0],
            ...beforeAgreements,
            ...agreements,
            ...afterAgreements,
          ],
          agreementsLength: agreements.length,
          firstAgreementStepIndex: beforeAgreements.length + 1, // add one to take first screen into account
          form: {
            // fields: { $set: newFormFields },
            fields: finalFields,
          },
          imageBlobUrl: { $set: state.imageBlobUrl },
        });
      });
      setLoading(false);
    };
    run();
  }, []);

  if (loading && state.onBoardingData) {
    return <p>Loading...</p>;
  } else {
    const checkFields = () => {
      const fields = state?.form?.fields;
      // Get errors
      const validationBlockInputs = [];

      if (fields) {
        Object.values(fields).forEach((item) => {
          if (item.hasOwnProperty('validateRule') && item.error) {
            validationBlockInputs.push(item.label);
          }
        });
      }

      // Not valid
      if (validationBlockInputs.length) {
        return validationBlockInputs;
      }
    };

    const updateFieldValue = (fk, value, error) => {
      setState((state) =>
        update(state, {
          form: {
            fields: {
              // FIXME - Make sure validation works as expected.
              [fk]: {
                value: { $set: value },
                error: { $set: error },
              },
            },
          },
          showValidateBlock: { $set: false },
        }),
      );
    };

    const onSubmit = () => {
      const { fields } = state.form;
      const data = {};

      // Get errors
      const validationBlockInputs = [];
      Object.values(fields).forEach((item) => {
        if (item.hasOwnProperty('validateRule') && item.error) {
          validationBlockInputs.push(item.label);
        }
      });
      
      // Not valid
      if (validationBlockInputs.length) {
        return setState({ ...state, showValidateBlock: true, validationBlockInputs });
      }

      Object.keys(fields).map((key) => (data[key] = fields[key].value));
      const tags = extractTags(fields, userProfileProps.userTags);

      const token = getCookieValForKey('token');
      if (token.success === false) {
        alert('An error occurred, please try again or contact support')
      }

      if (state.imageFile) {
        userProfileProps.postUserAvatar({
          image: state.imageFile,
          token: token.key,
        });
      }

      userProfileProps.createUserProfile({
        ...data,
        tags,
        token: token.key,
        callback: (preloaderId) => setTimeout(() => {
          dispatch(removePreloaderToGlobalPreloadersList(preloaderId));
          userProfileProps.history('/')
        }, 1000)
      })
    };

    const _renderField = (key) => {
      const { type, placeholder, label, validateRule, value, error, helperText, inputType } =
        state.form.fields[key];

      return (
        <TextField
          key={key}
          fk={key}
          type={type}
          inputType={inputType}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          value={value}
          validateRule={validateRule}
          validateObj={{ [validateRule]: value }}
          error={error}
          showError={state.form.validate}
          updateFieldData={updateFieldValue}
        />
      );
    };

    const setStep = (value) => {
      setSearchParams('currentStep', value);
      setState({ ...state, screenIndex: value, currentAgreementAccepted: false });

      const newLocation = {
        ...location,
        search: `?currentStep=${value}${value >= state.onBoardingData.length ? '&profile=true' : ''}`,
      };
      history(newLocation);
    };

    const _goNext = () => {
      const isProfile = profile || null;

      const isAnAgreementScreen =
        currentStep - 1 >= state.firstAgreementStepIndex &&
        currentStep - 1 < state.firstAgreementStepIndex + state.agreementsLength;

      // every agreement step requires to be accepted
      if (isAnAgreementScreen) {
        // check that the current agreement is accepted
        if (state.currentAgreementAccepted === false) return;
        ConsentsApi.setConsentsAgreed({
          engage4: true,
          engage4Terms: true,
          organisation: true,
        });
        // then reset for the next step
        setState({ ...state, currentAgreementAccepted: false });
      }

      if (isProfile) {
        return onSubmit();
      } else if (currentStep !== state?.onBoardingData?.length) {
        return setStep(state.screenIndex + 1);
      } else {
        userProfileProps.history('/');
      }
    };

    const _renderSelect = ({ key, options, label }) => {
      const { validateRule, value, error } = state.form.fields[key];
      return (
        <SelectField
          placeholder={label}
          options={options}
          key={key}
          fk={key}
          value={value}
          validateRule={validateRule}
          validateObj={{ [validateRule]: value }}
          error={error}
          showError={state.form.validate}
          updateFieldData={updateFieldValue}
        />
      );
    };

    const _renderCheckbox = (key) => {
      const { value, label } = state.form.fields[key];

      return (
        <CheckboxField
          key={key}
          fk={key}
          value={value}
          label={label}
          updateFieldData={updateFieldValue}
        />
      );
    };

    const _renderUserTags = () => {
      const { userTags } = userProfileProps;

      return userTags.map(({ type, id, options, title }) => {
        const key = `tag-${id}`;

        if (!state.form.fields[key]) return null;
        if (type === 1)
          return _renderSelect({
            ...state.form.fields[key],
            key,
            label: title,
            options: options.map((value) => ({
              value: value.id,
              displayName: value.label,
            })),
          });
        if (type === 2) return _renderCheckbox(key);
        else return null;
      });
    };

    const renderForm = () => {
      return (
        <div style={{ marginLeft: 30, marginRight: 60 }}>
          <h3 className="title">Create profile</h3>
          <div className="on-boarding">
            <input
              ref={fileUpload}
              className="d-none"
              type="file"
              accept="image/x-png,image/jpeg,image/gif"
              onChange={(e) => {
                setState({
                  ...state,
                  imageFile: e.target.files[0],
                  imageBlobUrl: URL.createObjectURL(e.target.files[0]),
                });
              }}
            />

            <div className="upload-img-holder" onClick={() => fileUpload.current.click()}>
              <Avatar
                size={97}
                src={typeof state.imageBlobUrl !== 'string' ? userPlaceholder : state.imageBlobUrl}
                shape="square"
              />
              <AddIcon className="add-img" />
            </div>

            <p className="picture-text">Profile picture</p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
              className="user-profile-form"
            >
              {_renderField('first_name')}
              {_renderField('last_name')}
              {_renderField('job_title')}
              {_renderField('phone_number')}
              {_renderSelect({
                key: 'department_id',
                label: 'Department',
                options: userProfileProps.departments.map((value) => ({
                  value: value.id,
                  displayName: value.department,
                })),
              })}
              {_renderUserTags()}
              <p className="mt-4">
                If you enter your phone number it will be visible when a colleague visits your
                profile
              </p>
              {state.showValidateBlock ? (
                <>
                  <div className="validate-block">
                    <p>Looks like you made some mistakes, check the following fields:</p>
                    <ul>
                      {state.validationBlockInputs.map((input) => (
                        <li key={input}>{input}</li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : null}
            </form>
          </div>
        </div>
      );
    };

    const renderScreens = (targetIndex) => {
      const onboardScreenToRender =
        state && state.onBoardingData && state.onBoardingData[targetIndex - 1];

      if (!onboardScreenToRender) return null;
      else
        return (
          <div
            className=" d-flex flex-column "
            style={{ overflowY: 'scroll', paddingBottom: '84px' }}
          >
            <OnBoardingScreen
              screen={onboardScreenToRender}
              customAppId={userProfileProps.customAppId}
            />
          </div>
        );
    };

    const { onBoardingData } = state;

    const showingProfileForm = profile;

    const validationBlocks = checkFields() || [];

    let progressBarWidth = 0;
    if (!onBoardingData?.length) progressBarWidth = 0;
    else {
      progressBarWidth = (100 / (onBoardingData?.length + 1 || 0)) * (currentStep + 1);
    }

    return (
      <div className="on-boarding w-100 overflow-auto">
        <div className={'w-100 h-100 bg-white overflow-auto'}>
          <Container fluid style={{ maxWidth: '1465px' }}>
            <div>
              {showingProfileForm ? null : (
                <div className={'progress-bar-container'}>
                  <ProgressBar
                    width={progressBarWidth}
                    backLabel={currentStep > 0 ? 'Skip Onboarding' : ''}
                    onGoBackClick={() =>
                      userProfileProps.history(
                        `/onboarding?currentStep=${state.firstAgreementStepIndex + 1}`,
                      )
                    }
                  />
                </div>
              )}
            </div>
            <Row>
              <Col className="no-padding">
                <div>
                  {currentStep - 1 === 0 || currentStep <= 0 ? null : (
                    <p className="back-to-form" onClick={() => setStep(currentStep - 1 || 0)}>
                      <FontAwesomeIcon
                        icon={['fas', 'chevron-left']}
                        className="back-to-form-icon"
                      />
                      Back to {`Onboarding Step ${currentStep - 1}`}
                    </p>
                  )}
                </div>
                <div className="create-profile__left-panel">
                  {showingProfileForm ? renderForm() : renderScreens(currentStep)}
                  <div className="onboarding-privacy-bottom-container">
                    {currentStep - 1 >= state.firstAgreementStepIndex &&
                      currentStep - 1 < state.firstAgreementStepIndex + state.agreementsLength && (
                        <div className="w-100 d-flex align-items-center justify-content-center">
                          <div
                            className="d-flex align-items-center justify-content-start agreements-checkbox-container"
                            style={{ position: 'relative' }}
                          >
                            <Checkbox
                              style={{ position: 'relative' }}
                              className="onboarding-agreements-checkbox"
                              checked={state.currentAgreementAccepted}
                              onChange={() =>
                                setState({
                                  ...state,
                                  currentAgreementAccepted: !state.currentAgreementAccepted,
                                })
                              }
                            >
                              <span style={{ color: 'rgba(0,0,0,.65)' }}>
                                I have read and accepted
                              </span>
                            </Checkbox>
                          </div>
                        </div>
                      )}

                    <div className="onboarding button-container">
                      <div>
                        <Button.Primary
                          onClick={_goNext}
                          type="large"
                          className="onboarding-next-button"
                          disabled={validationBlocks && validationBlocks.length}
                        >
                          {state.onBoardingData &&
                          state.onBoardingData[currentStep - 1]?.ctaButtonTitle
                            ? onBoardingData[currentStep - 1].ctaButtonTitle
                            : onBoardingData?.length && currentStep === onBoardingData?.length
                              ? 'FINISH'
                              : 'NEXT'}
                        </Button.Primary>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="no-padding">
                <div className="create-profile__right-panel">
                  <img
                    className="create-profile__panel-img"
                    src={CUSTOM_THEME.engage4.welcome}
                    alt="onboarding_image"
                  />
                  {/* {state.imageUrl !== 'LOADING' &&
                    (state.imageUrl ? (
                      <img className="create-profile__panel-img" src={state.imageUrl} alt="" />
                    ) : (
                      <img className="create-profile__panel-img" src={imgTeams} alt="" />
                    ))} */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
};

export default UserProfile;
